import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../components'
import { Container, Spinner, Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled, {keyframes} from "styled-components";
import { useSelector } from 'react-redux';
import {COLORS} from "../theme";

export function Loader(props) {
  const { t } = useTranslation();

  function Content({children}) {
    const minHeight = props.minHeight ?? "400px"
    return (<Row className="justify-content-center align-items-center spinner-wrapper" style={{minHeight: minHeight}}>
      {children}
    </Row>)
  }
  function Placeholder({children}) {
    if (props.as) {
      return React.createElement(
        props.as,
        {},
        <Content children={children}/>
      )
    } else {
      return (<Container fluid>
        <Content>
          {children}
        </Content>
      </Container>)
    }
  }

  if (props.success) {
    return props.children
  } else if (props.error) {
    return (<Placeholder>
      {t("error")}.
      {props.retry && <Button variant="primary" onClick={ () => props.retry() }>
        <Icon icon="retry" text={t("retry")} />
      </Button>}
    </Placeholder>)
  } else {
    return (<Placeholder>
      <Spinner className="spinner" animation="border" variant="primary" />
    </Placeholder>)
  }
}

Loader.propTypes = {
  children: PropTypes.node
}

export function useLoader(getData) {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const setLoading = () => {
    setError(false);
    setSuccess(false);
  }

  useEffect(() => {
    let mounted = true;
    if(mounted){
      getData && getData();
    }
    return () => {
      mounted = false;
    }
  }, []);

  function onSuccess() {
    setSuccess(true);
  }

  function onError() {
    setError(true);
  }

  const loaderRetry = () => {
    setLoading();
    getData();
  }

  const loaderProps = {
    success: success,
    error: error,
    retry: getData && loaderRetry
  }

  return {onSuccess, onError, loaderProps, loaderRetry, setLoading};
}

useLoader.PropTypes = {
  getData: PropTypes.func
}

const FullPageLoaderDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: radial-gradient(#000000BB, #000000DD);
`;

const blink = keyframes`
  50% {
    color: transparent
  }
`;

const LoaderDot = styled.span`
  &:before { content: "."}
  animation: 1s ${blink} infinite;
  &:nth-child(2) { animation-delay: 250ms }
  &:nth-child(3) { animation-delay: 500ms }
  margin-left: 3px;
`;

export function FullPageLoader() {

  const show = useSelector(state => state.loader.display)
  const text = useSelector(state => state.loader.text)

  if (show) {
    return (
    <FullPageLoaderDiv>
      <Row className="justify-content-center align-items-center" style={{
        height: "100%",
        color: `${COLORS.primary}`,
        fontSize: '14px',
        fontFamily: 'Gotham',
        fontWeight: 'bold',
        textTransform: 'uppercase',
      }}>
        {text} <LoaderDot/> <LoaderDot/> <LoaderDot/>
      </Row>
    </FullPageLoaderDiv>
    )
  } else {
    return null
  }
}
